module.exports = __webpack_public_path__ + "static/media/bell.11fbb280.svg";